import { Button, Text } from 'pcln-design-system';
import React from 'react';
import analytics from '../analytics/analytics';
export const handleChooseHotelRoomButtonClick = ({
  hotelId,
  args,
  detailURL,
  clickedOnMap = 'N'
}) => event => {
  var _a, _b;
  // Note: this handler will be used at multiple places
  // - HotelListingCard
  // - MapPinElement
  // When used in Map, the event will be MAP event instead of normal click event
  // There is no stopPropagation and preventDefault on MAP event
  (_a = event.stopPropagation) === null || _a === void 0 ? void 0 : _a.call(event);
  (_b = event.preventDefault) === null || _b === void 0 ? void 0 : _b.call(event);
  analytics.log(Object.assign({
    label: 'HotelSearchResult',
    hotelId: hotelId,
    message: 'HOTEL_DETAIL_LINK_CLICKED',
    clickedOnMap
  }, args));
  window.open(detailURL, '_blank');
};
export const ChooseHotelRoomButton = props => {
  const {
    buttonProps,
    buttonCopy,
    detailURL,
    hotelId,
    args
  } = props;
  return React.createElement(Button, Object.assign({}, buttonProps, {
    onClick: handleChooseHotelRoomButtonClick({
      hotelId,
      args,
      detailURL
    })
  }), React.createElement(Text, {
    bold: true,
    fontSize: 0
  }, buttonCopy));
};
ChooseHotelRoomButton.defaultProps = {
  buttonCopy: 'Choose Room',
  buttonProps: {},
  detailURL: '',
  hotelId: '',
  args: {}
};